import { html, ref, slotted } from '@microsoft/fast-element';
import { endSlotTemplate, startSlotTemplate, whitespaceFilter, } from '@microsoft/fast-foundation';
/**
 * @privateRemarks TODO: Raise PR against FAST
 * Unfortunately this template is almost a complete duplicate of the original fast version, just with additional
 * input atts required for auto completion.
 * Taken from `@microsoft/fast-foundation.46.2`
 */
export const foundationTextFieldTemplate = (context, definition) => html `
  <template
    class="
            ${(x) => (x.readOnly ? 'readonly' : '')}
        "
  >
    <label
      part="label"
      for="${(x) => (x.id ? x.id : 'control')}"
      class="${(x) => x.defaultSlottedNodes && x.defaultSlottedNodes.length ? 'label' : 'label label__hidden'}"
    >
      <slot ${slotted({ property: 'defaultSlottedNodes', filter: whitespaceFilter })}></slot>
    </label>
    <div class="root" part="root">
      ${startSlotTemplate(context, definition)}
      <input
        name="${(x) => x.name}"
        autocomplete="${(x) => x.autocomplete}"
        autocapitalize="${(x) => x.autocapitalize}"
        id="${(x) => (x.id ? x.id : 'control')}"
        class="control"
        part="control"
        @input="${(x) => x.handleTextInput()}"
        @change="${(x) => x.handleChange()}"
        step="${(x) => x.step}"
        ?autofocus="${(x) => x.autofocus}"
        ?disabled="${(x) => x.disabled}"
        list="${(x) => x.list}"
        maxlength="${(x) => x.maxlength}"
        minlength="${(x) => x.minlength}"
        pattern="${(x) => x.pattern}"
        placeholder="${(x) => x.placeholder}"
        ?readonly="${(x) => x.readOnly}"
        ?required="${(x) => x.required}"
        size="${(x) => x.size}"
        ?spellcheck="${(x) => x.spellcheck}"
        :value="${(x) => x.value}"
        type="${(x) => x.type}"
        aria-atomic="${(x) => x.ariaAtomic}"
        aria-busy="${(x) => x.ariaBusy}"
        aria-controls="${(x) => x.ariaControls}"
        aria-current="${(x) => x.ariaCurrent}"
        aria-describedby="${(x) => x.ariaDescribedby}"
        aria-details="${(x) => x.ariaDetails}"
        aria-disabled="${(x) => x.ariaDisabled}"
        aria-errormessage="${(x) => x.ariaErrormessage}"
        aria-flowto="${(x) => x.ariaFlowto}"
        aria-haspopup="${(x) => x.ariaHaspopup}"
        aria-hidden="${(x) => x.ariaHidden}"
        aria-invalid="${(x) => x.ariaInvalid}"
        aria-keyshortcuts="${(x) => x.ariaKeyshortcuts}"
        aria-label="${(x) => x.ariaLabel}"
        aria-labelledby="${(x) => x.ariaLabelledby}"
        aria-live="${(x) => x.ariaLive}"
        aria-owns="${(x) => x.ariaOwns}"
        aria-relevant="${(x) => x.ariaRelevant}"
        aria-roledescription="${(x) => x.ariaRoledescription}"
        ${ref('control')}
      />
      ${endSlotTemplate(context, definition)}
    </div>
  </template>
`;
